import { useNavigate } from "react-router-dom";
import { ChevronRight, Camera, CloudOff, Info, LogOut, Package, Settings, ShieldCheck, UserCog } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function Mehr() {
    const { user, role, signOut } = useAuth();
    const navigate = useNavigate();
    return (
        <section className="flex flex-col gap-4" data-testid="mehr-page">
            <div>
                <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Floor Mode</div>
                <h1 className="text-3xl font-bold tracking-tight text-foreground">Mehr</h1>
            </div>

            <div className="rounded-xl border border-border bg-card/60 p-4">
                <div className="text-xs text-muted-foreground">Angemeldet als</div>
                <div className="text-sm font-medium text-foreground">{user?.email}</div>
                <div className="mt-1 inline-flex items-center gap-1 rounded-full border border-border px-2 py-0.5 text-xs uppercase tracking-widest text-muted-foreground">
                    {role}
                </div>
            </div>

            <button
                type="button"
                onClick={() => navigate("/einstellungen")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-einstellungen"
            >
                <Settings className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Einstellungen</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            <button
                type="button"
                onClick={() => navigate("/artikel")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-artikel"
            >
                <Package className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Artikel — wo liegt was?</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            <button
                type="button"
                onClick={() => navigate("/ausleihen")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-ausleihen"
            >
                <UserCog className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Ausleihen — wer hat was?</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            <button
                type="button"
                onClick={() => navigate("/mehr/queue")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-ops-queue"
            >
                <CloudOff className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Operation-Queue</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            <button
                type="button"
                onClick={() => navigate("/mehr/fotos-queue")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-foto-queue"
            >
                <Camera className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Foto-Queue</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            {role === "admin" ? (
                <button
                    type="button"
                    onClick={() => navigate("/admin")}
                    className="pw-tap flex items-center gap-3 rounded-lg border border-primary/40 bg-card/40 px-3 py-3 text-left"
                    data-testid="mehr-admin"
                >
                    <ShieldCheck className="h-5 w-5 text-primary" />
                    <span className="flex-1 text-sm font-medium text-primary">
                        Admin-Bereich
                    </span>
                    <ChevronRight className="h-4 w-4 text-primary" />
                </button>
            ) : null}

            <button
                type="button"
                onClick={() => navigate("/hilfe")}
                className="pw-tap flex items-center gap-3 rounded-lg border border-border bg-card/40 px-3 py-3 text-left hover:border-primary/40"
                data-testid="mehr-hilfe"
            >
                <Info className="h-5 w-5 text-muted-foreground" />
                <span className="flex-1 text-sm">Hilfe &amp; Über Platzwart</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </button>

            <button
                type="button"
                onClick={async () => {
                    await signOut();
                    navigate("/login", { replace: true });
                }}
                className="pw-tap mt-4 flex items-center justify-center gap-2 rounded-lg border border-destructive/40 bg-[rgb(var(--destructive-bg))] px-3 py-3 text-destructive"
                data-testid="mehr-logout"
            >
                <LogOut className="h-4 w-4" />
                <span className="text-sm font-medium">Abmelden</span>
            </button>
        </section>
    );
}
